// mapper.ts
import { MixDetails } from './LocalDatabase';
import { ShishaMix } from '../types';

export function mapDbMixToShishaMix(dbMix: MixDetails): ShishaMix {
  let creatorName = 'ShishaKnight';
  let creatorAvatar = '';

  if (dbMix.user_id === 'local-user') {
    const authData = localStorage.getItem('hf_auth_user');
    if (authData) {
      try {
        const user = JSON.parse(authData);
        creatorName = user.username || 'no name';
        if (user.avatarUrl) {
          creatorAvatar = user.avatarUrl;
        }
      } catch (e) {
        creatorName = 'no name';
      }
    } else {
      creatorName = 'no name';
    }
  } else if (dbMix.user_id === 'withdrawn-user') {
    creatorName = '退会済みユーザー';
    creatorAvatar = '';
  }

  return {
    id: dbMix.id,
    title: dbMix.name,
    description: dbMix.impression || '',
    creator: creatorName,
    creatorAvatar: creatorAvatar,
    flavors: dbMix.flavors.map((f) => ({
      flavor_id: f.flavor_id,
      brand: f.brand_name,
      name: f.flavor_name,
      ratio: f.ratio,
      color: f.color,
    })),
    tags: dbMix.is_public ? ['公開中'] : ['ローカル保存'],
    tastingNotes: {
      sweetness: 3,
      coolness: 3,
      spiciness: 3,
      richness: 3,
    },

    likes: dbMix.is_public ? 124 : 0,
    bookmarks: dbMix.is_public ? 89 : 0,
    rating: dbMix.rating || 5.0,
    comments: [],
    createdAt: dbMix.created_at.split('T')[0],
  };
}
